import React, { Component } from 'react';
import $ from '../../../common/AjaxRequest';
import { Modal, Button, Icon, message, Tree, Input } from 'antd';
import API_URL from '../../../common/url';

const TreeNode = Tree.TreeNode;

class CasCadeOption extends Component {
    state = {
        options : [],
        expandedKeys: [],
        visible: false,
    };

    show = (id) => {
        this.setState({
            id,
            visible: true,
        }, () => {
            this.loadData();
        });
    };

    hide = () => {
        this.setState({
            visible: false,
            showCascader: false,
            expandedKeys: [],
        });
    };

    loadData = (followBoardDetailOptionId) => {
        const { id, expandedKeys } = this.state;
        const options = {
            method: 'POST',
            url: `${API_URL.executeMgr.queryCascadeListByDetailId}`,
            data: {
                followBoardDetailId: id,
                investigationId: sessionStorage.invId,
            },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    this.setState({
                        dataList: res.optionList,
                        expandedKeys: [...expandedKeys, followBoardDetailOptionId],
                    });
                }
            }),
        };
        $.sendRequest(options);
    }

    deleteConfirm = (followBoardDetailOptionId, optionName) => {
        Modal.confirm({
            iconType: 'exclamation-circle',
            title: `确定要删除选项“${optionName}”吗?`,
            onOk: () => {
                this.deleteCascade(followBoardDetailOptionId, optionName);
            },
        });
    }

    deleteCascade = (followBoardDetailOptionId, optionName) => {
        const options = {
            method: 'POST',
            url: `${API_URL.executeMgr.delDetailOption}`,
            data: {
                optionName,
                followBoardDetailOptionId,
                investigationId: sessionStorage.invId,
            },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    message.success(res.success);
                    this.loadData();
                }
            }),
        };
        $.sendRequest(options);
    }

    getDataList = () => {
        const { dataList = [] } = this.state;
        let data = null;
        if (dataList.length > 0) {
            data = this.loopMap(dataList);
        }
        return data;
    }

    onExpand = (expandedKeys, node) => {
        this.setState({ expandedKeys });
    }

    showSetOption = params => {
        const { id } = this.state;
        params.followBoardDetailId = id;
        this.SetOptionRef.show(params);
    }

    loopMap = data => {
        return data.map(item => {
            if (item.childList && (item.childList.length > 0)) {
                return (
                    <TreeNode
                        title={<div className="violate_item">{item.optionName}
                        {
                            item.investigationId
                            ?
                                <span>
                                    <Icon onClick={() => this.showSetOption({type: 'add', parentId: item.followBoardDetailOptionId, optionName: ''})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="plus-circle-o" />
                                    <Icon onClick={() => this.showSetOption({type: 'edit', followBoardDetailOptionId: item.followBoardDetailOptionId, optionName: item.optionName})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="edit" />
                                    <Icon onClick={() => this.deleteConfirm(item.followBoardDetailOptionId, item.optionName)} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#F00', cursor: 'pointer'}} type="close" />
                                </span>
                            :
                                item.leafState &&
                                <Icon onClick={() => this.showSetOption({type: 'add', parentId: item.followBoardDetailOptionId, optionName: ''})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="plus-circle-o" />
                        }
                        </div>}
                        key={item.followBoardDetailOptionId + ''}
                    >
                        { this.loopMap(item.childList) }
                    </TreeNode>
                )
            } else {
                if (item.optionLevel < 6) {
                    return (
                        <TreeNode
                            title={<div className="violate_item">{item.optionName}
                            {
                                item.investigationId
                                ?
                                    <span>
                                        <Icon onClick={() => this.showSetOption({type: 'add', parentId: item.followBoardDetailOptionId, optionName: ''})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="plus-circle-o" />
                                        <Icon onClick={() => this.showSetOption({type: 'edit', followBoardDetailOptionId: item.followBoardDetailOptionId, optionName: item.optionName})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="edit" />
                                        <Icon onClick={() => this.deleteConfirm(item.followBoardDetailOptionId, item.optionName)} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#F00', cursor: 'pointer'}} type="close" />
                                    </span>
                                :
                                    <Icon onClick={() => this.showSetOption({type: 'add', parentId: item.followBoardDetailOptionId, optionName: ''})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="plus-circle-o" />
                            }
                            </div>}
                            key={item.followBoardDetailOptionId + ''}
                        />
                    )
                } else if (item.optionLevel >= 6) {
                    return (
                        <TreeNode
                            title={<div className="violate_item">{item.optionName}
                                {
                                    item.investigationId &&
                                    <span>
                                        <Icon onClick={() => this.showSetOption({type: 'edit', followBoardDetailOptionId: item.followBoardDetailOptionId, optionName: item.optionName})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="edit" />
                                        <Icon onClick={() => this.deleteConfirm(item.followBoardDetailOptionId, item.optionName)} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#F00', cursor: 'pointer'}} type="close" />
                                    </span>
                                }
                            </div>}
                            key={item.followBoardDetailOptionId + ''}
                        />
                    )
                } else {
                    return <TreeNode title={item.optionName} key={item.followBoardDetailOptionId + ''} />
                }
            }
        })
    }

    render() {
        const { visible, expandedKeys } = this.state;
        return (
            visible &&
            <Modal
                title="设置可选项"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal footer-center"
                wrapClassName="vertical-center-modal"
                width="600px"
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div>
                    <div className="modal-content">
                        <ul className="modal-list">
                            <li className="modal-item" style={{paddingBottom: 20}}>
                                <Tree
                                    showLine
                                    onExpand={this.onExpand}
                                    expandedKeys={expandedKeys}
                                >
                                    { this.getDataList() }
                                </Tree>
                            </li>
                        </ul>
                    </div>
                    <SetOption ref={el => this.SetOptionRef = el} reLoad={this.loadData} />
                </div>
            </Modal>
        );
    }
}

class SetOption extends Component {
    state = {
        visible: false,
        confirmLoading: false,
    };

    show = params => {
        this.setState({
            params,
            visible: true
        });
    };

    hide = () => {
        this.setState({ visible: false });
    };

    confirm = () => {
        const { params } = this.state;
        const { type, optionName = '' } = params;
        if (optionName.trim() == '') {
            message.warning('请输入选项名称');
            return;
        }
        const  url = type == 'add' ? API_URL.executeMgr.addDetailOption : API_URL.executeMgr.editDetailOption;

        this.setState({ confirmLoading: true });
        const options = {
            method: 'POST',
            url,
            data: {
                ...params,
                investigationId: sessionStorage.invId,
            },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    message.success(type == 'add' ? '添加可选项成功' : '修改可选项成功');
                    this.setState({
                        visible: false,
                        confirmLoading: false,
                    }, () => {
                        this.props.reLoad(res.followBoardDetailOption.followBoardDetailOptionId + '');
                    });
                } else {
                    message.error(res.error);
                    this.setState({ confirmLoading: false });
                }
            }),
            errorResult: (() => {
                this.setState({ confirmLoading: false });
            })
        };
        $.sendRequest(options);
    }

    handleInputChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params });
    }

    render() {
        const { visible, confirmLoading, params = {} } = this.state;
        const { optionName = '', type = '' } = params;
        return (
            <Modal
                title={ type == 'add'? '添加选项' : '修改选项'}
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                className="preview-modal footer-center"
                wrapClassName="vertical-center-modal"
                width="400px"
                confirmLoading={confirmLoading}
            >
                <div className="modal-content">
                    <ul className="modal-list">
                        <li className="modal-item" style={{paddingBottom: 20}}>
                            <div className="item-left" style={{width: 86, paddingRight: 10}}>选项名称:</div>
                            <div className="item-right">
                                <Input
                                    maxLength='30'
                                    value={optionName}
                                    placeholder="请输入选项名称"
                                    onChange={e => this.handleInputChange(e, 'optionName')}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

class SelectOption extends Component {
    state = {
        visible: false,
    };

    show = (id) => {
        this.setState({
            id,
            visible: true,
        }, () => {
            this.loadData();
        });
    };

    hide = () => {
        this.setState({
            visible: false,
        }, () => {
            this.props.loadData();
        });
    };

    loadData = () => {
        const { id } = this.state;
        const options = {
            method: 'POST',
            url: `${API_URL.executeMgr.queryCascadeListByDetailId}`,
            data: {
                followBoardDetailId: id,
                investigationId: sessionStorage.invId,
            },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    this.setState({
                        dataList: res.optionList,
                    });
                }
            }),
        };
        $.sendRequest(options);
    }

    handleInputChange = e => {
        this.setState({ optionName: e.target.value });
    }

    handleAddBtn = () => {
        const { optionName, id } = this.state;
        if (optionName.trim() == '') {
            message.warning('请输入可选项');
            return;
        }

        const options = {
            method: 'POST',
            url: API_URL.executeMgr.addDetailOption,
            data: {
                optionName,
                followBoardDetailId: id,
                investigationId: sessionStorage.invId,
            },
            dataType: 'json',
            doneResult: ( res => {
                if (!res.error) {
                    message.success('编辑成功');
                    this.setState({
                        optionName: '',
                    }, () => {
                        this.loadData();
                    })
                }
            }),
        };
        $.sendRequest(options);
    }

    handleRemoveItem = (e, text, id) => {
        Modal.confirm({
            iconType: 'exclamation-circle',
            title: `确定要删除选项“${text}”吗?`,
            onOk: () => {
                const options = {
                    method: 'POST',
                    url: API_URL.executeMgr.delDetailOption,
                    data: {
                        followBoardDetailOptionId: id,
                        investigationId: sessionStorage.invId,
                    },
                    dataType: 'json',
                    doneResult: (res => {
                        if (!res.error) {
                            message.success('编辑成功');
                            this.loadData();
                        } else {
                            message.error(res.error);
                        }
                    }),
                };
                $.sendRequest(options);
            }
        });
    }

    getDataList = () => {
        const { dataList = [] } = this.state;
        let data = null;
        if (dataList.length > 0) {
            data = dataList.map((item, index) => 
                <div key={index}>
                    <div style={{position: 'relative', marginBottom: 4, paddingLeft: 10, paddingRight: 20, background: '#f1f1f1'}}>
                        <div title={item} style={{overflow: 'hidden', wordSpace: 'no-wrap', textOverflow: 'ellipsis'}}>{item.optionName}</div>
                        {
                            item.investigationId !== 0 &&
                            <Icon style={{position: 'absolute', top: 5, right: 5, color: 'red', cursor: 'pointer'}}type="close-circle-o" onClick={e => this.handleRemoveItem(e, item.optionName, item.followBoardDetailOptionId)}/>
                        }
                    </div>
                </div>   
            )
        }
        return data;
    }

    render() {
        const { visible, optionName = '' } = this.state;
        return (
            <Modal
                title="设置可选项"
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                className="preview-modal footer-center"
                wrapClassName="vertical-center-modal"
                width="440px"
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div className="modal-content">
                    <ul className="modal-list">
                        <li className="modal-item" style={{paddingBottom: 20, borderBottom: '1px solid #dcdcdc'}}>
                            <div className="item-left" style={{width: 86, paddingRight: 10}}><span style={{color: 'red'}}>*</span>可选项:</div>
                            <div className="item-right" style={{width: 190}}>
                                <Input placeholder='请输入' value={optionName} onChange={this.handleInputChange}/>
                            </div>
                            <Button type="primary" style={{marginLeft: 20}} onClick={this.handleAddBtn}>添加</Button>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{width: 86, paddingRight: 10}}>已添加可选项:</div>
                            <div className="item-right" style={{width: '73%'}}>
                            { this.getDataList() }
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export { CasCadeOption, SelectOption };


// WEBPACK FOOTER //
// ./src/components/executeMgr/template/TemplateModal.js